// Hooks (react-router-dom) imports
import { useNavigate } from "react-router-dom";

// Custom hooks Redux imports
import { useAppSelector } from "../../../../app/hook";

// Third helpers imports
import { confirmChange } from "../../../../features/auth/helpers";

function CreatePlanActions() {
  const currentUser = useAppSelector((state) => state.auth.user);
  const navigate = useNavigate();

  return (
    <div className="w-full grid sm:col-span-4 grid-cols-2 gap-x-6 p-4">
      <button
        className="button-secondary text-sm py-2 px-4"
        onClick={() => {
          confirmChange(
            "¿Estas seguro de cancelar la creación del plan?",
            "Al cancelar, todos los cambios seran ignorados",
            () => {
              navigate(`/${currentUser?.id}/planes`);
            }
          );
        }}
        type="button"
      >
        Cancelar
      </button>
      <button type="submit" className="button-primary text-sm py-2 px-4">
        Crear
      </button>
    </div>
  );
}

export default CreatePlanActions;
